import { Controller } from "@hotwired/stimulus"

// CONEK — Speed-dial toggle for `Ui::Mobile::FabComponent`'s menu mode
// (CONEK-4566). Mirrors `ui--dropdown`'s open/close/outside-click/Escape
// conventions, minus the backdrop + arrow-key menu navigation (a two-pill
// speed-dial doesn't need a focus trap).
//
// The menu wrapper starts `hidden` (see fab_component.html.erb) and is
// revealed on trigger click; the trigger's `aria-expanded` mirrors state.
//
// Registered as "ui--mobile--fab-menu".
export default class extends Controller {
  static targets = ["trigger", "menu"]

  connect() {
    this.escapeHandler = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.escapeHandler)

    this.outsideClickHandler = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.outsideClickHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.escapeHandler)
    document.removeEventListener("click", this.outsideClickHandler)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    if (!this.hasMenuTarget) return

    this.menuTarget.classList.remove("hidden")
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "true")
    }
  }

  close() {
    if (!this.hasMenuTarget) return

    this.menuTarget.classList.add("hidden")
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "false")
    }
  }

  handleEscape(event) {
    if (event.key === "Escape" && this.isOpen()) {
      this.close()
    }
  }

  handleOutsideClick(event) {
    if (this.isOpen() && !this.element.contains(event.target)) {
      this.close()
    }
  }

  isOpen() {
    return this.hasMenuTarget && !this.menuTarget.classList.contains("hidden")
  }
}
